export default __webpack_public_path__ + "static/thumb-landscape-a7bfbbab586a419efc1a39db074a8caa.jpg";